<template>
    <div>
        <div class="container text-center">
            <div v-if="loading" class="pt-5 pb-5 gold-spinner mx-auto spinner-border" role="status" aria-label="Loading...">
                <span class="visually-hidden">Loading...</span>
            </div>
            <ErrorMessage v-if="errored" class="pt-5 pb-5"
                          :errorNotification="'We’re sorry that didn’t work. Please try again.'"></ErrorMessage>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue'
    import { useStore } from 'vuex'
    import ErrorMessage from '@/components/ErrorMessage.vue'

    const loading = ref(true)
    const errored = ref(false)
    const store = useStore()

    onMounted(() => {
        store.dispatch("signinRedirectCallback")
            .catch((error) => {
                console.log(error)
                errored.value = true
            })
            .finally(() => {
                loading.value = false
            })
    })
</script>

<style lang="scss" scoped>
.container {
  height: 60vh;
}

.error-notification {
  height: unset;
}
</style>
